export default __webpack_public_path__ + "static/media/HRRealCase-en.4c2eabfa.jpg";